
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * LeverageProfileLeverageMode enum
 */
class LeverageProfileLeverageMode {
  /**
   * Initialize enum with a given value
   * @param {LeverageProfileLeverageMode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof LeverageProfileLeverageMode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!LeverageProfileLeverageMode}
   * @param {!LeverageProfileLeverageMode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof LeverageProfileLeverageMode)) {
      throw new TypeError('Instance of LeverageProfileLeverageMode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!LeverageProfileLeverageMode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!LeverageProfileLeverageMode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === LeverageProfileLeverageMode.EQUITY.value) {
      return 'EQUITY'
    }
    if (this.value === LeverageProfileLeverageMode.BALANCE.value) {
      return 'BALANCE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!LeverageProfileLeverageMode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!LeverageProfileLeverageMode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!LeverageProfileLeverageMode} Created enum
   */
  static fromObject (other) {
    return new LeverageProfileLeverageMode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
LeverageProfileLeverageMode.EQUITY = new LeverageProfileLeverageMode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
LeverageProfileLeverageMode.BALANCE = new LeverageProfileLeverageMode(0 + 1)

export { LeverageProfileLeverageMode };

/**
 * Fast Binary Encoding LeverageProfileLeverageMode field model
 */
class FieldModelLeverageProfileLeverageMode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelLeverageProfileLeverageMode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelLeverageProfileLeverageMode}
   * @param {LeverageProfileLeverageMode=} defaults Default value, defaults is new LeverageProfileLeverageMode()
   * @returns {!LeverageProfileLeverageMode} Result value
   */
  get (defaults = new LeverageProfileLeverageMode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new LeverageProfileLeverageMode(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelLeverageProfileLeverageMode}
   * @param {!LeverageProfileLeverageMode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelLeverageProfileLeverageMode };
